<template>
    <div class="card wdVidepPlaceholder" :style="{backgroundImage: 'url(' + coverImgUrl + ')', backgroundSize:'cover'}">
        <div class="card-header p-0 text-center">
        
        </div>
        <div class="card-body text-center">
            <appModalVideoPlaceHolder
            :title="title"
            :url="videoUrl"></appModalVideoPlaceHolder>
        </div>
        <p class="mb-0 bg-primary p-1 fs-800 fw-700">{{ title }}</p>
    </div>
</template>
<script>
import appModalVideoPlaceHolder from './ModalVideoPlaceHolder.vue';
export default {
    props:['coverImgUrl','title','videoUrl'],
    components:{
        appModalVideoPlaceHolder,
    },
    data(){
        return{
           
        }
    }
}
</script>
 